import { CommonModule } from '@angular/common';
import {
    AfterViewInit,
    Component,
    ElementRef,
    Input,
    OnInit,
    ViewChild,
} from '@angular/core';
import { TrustpilotService } from '@core/services/trustpilot.service';

@Component({
    selector: 'app-trustpilot-micro-combo-badge',
    imports: [CommonModule],
    templateUrl: './trustpilot-micro-combo-badge.component.html',
})
export class TrustpilotMicroComboBadgeComponent
    implements OnInit, AfterViewInit
{
    @Input() additionalClasses: string[] | string = [];
    @Input() theme: 'light' | 'dark' = 'dark';
    @ViewChild('trustbox') trustpilotWidgetElement!: ElementRef;

    cssClasses: string[];
    constructor(private trustpilotService: TrustpilotService) {}

    ngAfterViewInit() {
        this.trustpilotService
            .loadTrustPilotWidget(
                this.trustpilotWidgetElement.nativeElement,
                this.theme
            )
            .subscribe();
    }
    ngOnInit(): void {
        this.cssClasses = ['trustpilot-widget'].concat(this.additionalClasses);
    }
}
